module.exports = __webpack_public_path__ + "img/file-icon.995660f3.svg";